import cross from './cross.svg?raw'
import check from './check.svg?raw'

export default {
    cross,
    check
}
